import { AfterContentChecked, AfterContentInit, Component, ElementRef, OnInit } from '@angular/core';

declare var $: any;

@Component({
    selector: 'app-tabs-ng',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss']
})
export class TabsNgComponent implements OnInit, AfterContentInit, AfterContentChecked {

    constructor(private elRef: ElementRef) {
    }

    ngOnInit() {
        $('.tabs').tabs();
    }

    ngAfterContentInit(): void {
        $('.tabs').tabs();
    }

    ngAfterContentChecked(): void {
        $('.tabs').tabs();
    }


}
